import Navbar from "../components/Navbar";
import HomeHero from "../components/HomeHero";
import Destination from "../components/Destination";
import Footer from "../components/Footer";
import HomeBG from "src/assets/night.jpg";

function Home() {
  return (
    <>
      <Navbar />
      <HomeHero
        cName="hero"
        heroImg={HomeBG}
        title=""
        text=""
        btnClass="hide"
        buttonText="Travel Plan"
        url="/"
      />
      <Destination />
      {/* <Trip /> */}
      <Footer />
    </>
  );
}

export default Home;
